
<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>

<div id="loader" *ngIf="enableLoader"></div>

<div *ngIf="!enableLoader" class="availability-page">
  <div class="availability-toolbar">
    <div class="container availability-toolbar__inner">
      <div class="filter-group">
        <span class="filter-label">Filter by:</span>
        <ng-select
          class="material-filter"
          [items]="materialsData"
          [multiple]="true"
          [clearable]="false"
          bindLabel="name"
          dropdownPosition="bottom"
          [closeOnSelect]="true"
          placeholder="All materials"
          bindValue="name"
          [(ngModel)]="selectedMaterial"
          notFoundText="No Items Found"
          (change)="changeMaterial()">
          <ng-template ng-multi-label-tmp>
            <span class="filter-count">{{ selectedMaterial?.length }}x selected</span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-item$="item$">
            <input
              *ngIf="item?.name"
              id="{{ item.name }}"
              type="checkbox"
              [ngModel]="item$.selected"
              [checked]="item.selected" />
            <span>{{ item.name }}</span>
          </ng-template>
        </ng-select>
        <button *ngIf="showClear" type="button" class="clear-filter" (click)="clearAllFilters()">
          {{ 'home.productHeader.ClearFilter' | cxTranslate }}
        </button>
      </div>

      <div class="toolbar-actions">
        <span class="display-label">Display as:</span>
        <button type="button" class="view-toggle" [class.active]="isListView" (click)="toggleListView()" title="List view">
          <img [src]="listSrc" alt="List view">
        </button>
        <button type="button" class="view-toggle" [class.active]="isGridView" (click)="toggleGridView()" title="Grid view">
          <img [src]="gridSrc" alt="Grid view">
        </button>
        <div class="search-box">
          <input
            type="search"
            (keypress)="omitSpecialChar($event)"
            [(ngModel)]="searchText"
            id="bilateral-search-input"
            (input)="search()"
            placeholder="Search">
          <i class="fa fa-search"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="container availability-content">
    <div class="availability-header">
      <h2>Cathodes availability</h2>
      <button type="button" class="multi-material-btn">Select multiple material</button>
    </div>

    <ng-container *ngIf="groupedCargoes.length > 0; else emptyState">
      <section *ngFor="let group of groupedCargoes; let groupIndex = index" class="availability-group">
        <div class="group-heading">
          <div>
            <h3>{{ group.brand }}</h3>
            <p>{{ group.location }}</p>
          </div>
          <div class="row-controls" *ngIf="group.cargoes.length > 3">
            <button type="button" (click)="scrollRow(groupIndex, 'left')" aria-label="Scroll left">
              <i class="fa fa-chevron-left"></i>
            </button>
            <button type="button" (click)="scrollRow(groupIndex, 'right')" aria-label="Scroll right">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>

        <div class="cargo-row" #cargoCarousel [class.list-view]="isListView">
          <article class="cargo-tile" *ngFor="let cargo of group.cargoes">
            <div class="tile-accent" [style.background-color]="cargo.accentColor"></div>
            <div class="tile-body">
              <h4>{{ cargo.name }}</h4>
              <div class="tile-meta">
                <span>Qty: <strong>{{ cargo.quantity | number }} {{ cargo.quantityUnit }}</strong></span>
                <span>Schedule: <strong>{{ cargo.schedule }}</strong></span>
                <span>ETAD: <strong>{{ cargo.etad }}</strong></span>
                <span>Pb/s: <strong>{{ cargo.pbs }}</strong></span>
              </div>
              <div class="tile-actions">
                <button type="button" class="details-btn" (click)="viewDetails(cargo)">View details</button>
                <button type="button" class="bid-btn" (click)="placeBid(cargo)">Place bid</button>
              </div>
            </div>
          </article>
        </div>
      </section>
    </ng-container>

    <ng-template #emptyState>
      <div class="empty-state">
        <p>{{ 'home.productHeader.NoProducts' | cxTranslate }}</p>
      </div>
    </ng-template>
  </div>
</div>